import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';
import ContentPlaceholder from 'yoda-core-components/lib/components/ContentPlaceholder/ContentPlaceholder';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { selectDeviceName } from '../../selectors/ContextSelector';
import { getMaxSwatchLength } from '../../helpers/ProductOptions/ProductOptionsHelper';
import * as styles from './ProductOptions.css';

const ProductOptionsPlaceHolder = (props) => {
    const cx = classNames.bind(styles);
    const {
        dimension: { id: dimensionId },
        fromMiniPDP,
    } = props;
    const { enableColorCarousel = true } = useSelector(
        (state) => state.context?.featureFlags || {}
    );
    const deviceName = useSelector((state) => selectDeviceName(state));
    const productDetails = useSelector((state) => state.productDetails) || {};
    const isDimensionColor = dimensionId === 'COLOR';
    const swatchesMaxLn = getMaxSwatchLength(
        deviceName,
        fromMiniPDP,
        enableColorCarousel,
        productDetails
    );
    const reducer = (acc, cur, i, arr) => {
        const lastInRow = enableColorCarousel ? false : arr.length - 1 === i;
        const maskClass = enableColorCarousel ? 'maskColorCarousel' : 'mask';
        acc.push(<div className={cx(maskClass, lastInRow ? 'lastInRow' : '')} />);
        return acc;
    };
    let colorMasks;
    let loadingSwatchCount = 0;

    if (fromMiniPDP) {
        loadingSwatchCount = deviceName === 'tablet' ? 7 : 6;
    } else {
        loadingSwatchCount = deviceName === 'tablet' ? 6 : 10;
    }

    if (deviceName === 'desktop') {
        colorMasks = Array(isDimensionColor ? loadingSwatchCount : swatchesMaxLn)
            .fill(1)
            .reduce(reducer, [])
            .slice(0, isDimensionColor ? loadingSwatchCount : swatchesMaxLn);
    } else {
        colorMasks = Array(isDimensionColor ? loadingSwatchCount : swatchesMaxLn + 1)
            .fill(1)
            .reduce(reducer, [])
            .slice(0, isDimensionColor ? loadingSwatchCount : swatchesMaxLn + 1);
    }
    // if there's space after the last mask, cover it with a white div
    const mask = isDimensionColor ? (
        <div className={cx('swatchLoaderMasks', 'noScrollBar')}>
            {colorMasks}
            {!enableColorCarousel && <div className={cx('paddingMask')} />}
        </div>
    ) : (
        <div className={cx('optionLoaderMasks')}>
            {Array(4).fill(1).reduce(reducer, [])}
            <div className={cx('paddingMask', fromMiniPDP ? 'fromMiniPdp' : '')} />
        </div>
    );
    const mdAboveColorCaraouselStyle =
        enableColorCarousel && !fromMiniPDP
            ? dt(['lg:w-[560px]', 'mdOnly:w-[336px]', 'smOnly:w-full'])
            : dt(['w-full']);

    const miniPdpCarouselStyle =
        fromMiniPDP && enableColorCarousel
            ? dt(['lg:w-[372px]', 'mdOnly:w-[396px]', 'smOnly:w-full'])
            : dt(['w-full']);

    return (
        <div
            className={[
                cx('placeholderWrapper'),
                dt([fromMiniPDP && 'mt-2']),
                mdAboveColorCaraouselStyle,
                miniPdpCarouselStyle,
            ].join(' ')}
        >
            <ContentPlaceholder
                mask={mask}
                miniPDPMaskStyle={dt([
                    fromMiniPDP && 'lg:w-[336px]',
                    fromMiniPDP && 'mdOnly:w-[392px]',
                ])}
            />
        </div>
    );
};

ProductOptionsPlaceHolder.defaultProps = {
    dimension: {},
    fromMiniPDP: false,
};

ProductOptionsPlaceHolder.propTypes = {
    dimension: PropTypes.object,
    fromMiniPDP: PropTypes.bool,
};

export default ProductOptionsPlaceHolder;
